<template>
    <div id="new-report-filters" class="filters">
        <div class="row">
            <div class="col-sm-3" v-if="!isPostTypeReport()">
                <label class="control-label">Menü</label>
                <b-form-select v-model="filter.menu_id" class="form-control" :options="menu_list"></b-form-select>
            </div>
            <div class="col-sm-3">
                <label class="control-label">Típus</label>
                <b-form-select v-model="filter.post_type" class="form-control" :options="post_type_list"></b-form-select>
            </div>
            <div class="col-sm-3">
                <label class="control-label">Dátum-tól</label>
                <datepicker :format="dateFormatOptions" :value="filter.date_from"
                            @selected="dateFromSelected" input-class="filter-datepicker"
                            class="form-control"></datepicker>
            </div>
            <div class="col-sm-3">
                <label class="control-label">Dátum-ig</label>
                <datepicker :format="dateFormatOptions" :value="filter.date_to"
                            @selected="dateToSelected" input-class="filter-datepicker"
                            class="form-control"></datepicker>
            </div>
            <div class="col-sm-3" v-if="!isPostTypeReport() && !isPostVisitorsReport() && ! isPostCountReport()">
                <label class="control-label">Eszközök</label>
                <b-form-select v-model="filter.visitor_type" class="form-control" :options="visitor_types"></b-form-select>
            </div>
            <div class="col-sm-3">
                <label class="control-label">Szerző</label>
                <b-form-select v-model="filter.user_id" class="form-control" :options="user_list"></b-form-select>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-sm-2">
                <button class="btn btn-primary" @click="applyFiltersClick">Keresés</button>
            </div>
            <div class="col-sm-2">
                <button class="btn btn-secondary" @click="resetFiltersClick">Törlés</button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';
    import { mapActions, mapGetters } from 'vuex'
    import * as ReportTypes from '../constants/reportTypes'

    export default {
        name: 'new-report-filters',
        props: ['data'],
        data() {
            return {
                initialFilters: {
                    menu_id: '',
                    visitor_type: '',
                    post_type: '',
                    date_from: moment(new Date()).subtract(7, 'd').format('YYYY-MM-DD '),
                    date_to: moment(new Date()).format('YYYY-MM-DD '),
                    user_id: '',
                },
                visitor_types: [
                    { value: '', text: '-Minden eszköz-'},
                    { value: 'desktop', text: 'Számítógép '},
                    { value: 'mobile', text: 'Telefon '},
                    { value: 'android', text: 'Android'},
                ]
            }
        },
        components: {
            Datepicker
        },
        computed: {
            ...mapGetters([
                'report',
                'reportFilters',
                'postTypes',
                'users',
                'menuList',
            ]),
            filter: {
                get: function() {
                    return this.reportFilters ? this.reportFilters : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            filterParams: {
                get: function() {
                    return this.data ? this.data : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user_list() {
                let list = [
                    { value: '', text: '-Minden felhasználó-' }
                ];
                if(this.users) {
                    this.users.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.first_name+' '+item.last_name
                        });
                    });
                }

                return list;
            },
            menu_list() {
                let list = [
                    { value: '', text: '-Minden menü-' }
                ];
                if(this.menuList) {
                    this.menuList.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.name
                        });
                    });
                }

                return list;
            },
            post_type_list() {
                let list = [
                    { value: '', text: '-Minden típus-' }
                ];
                if(this.postTypes) {
                    this.postTypes.map((item) => {
                        list.push({
                            value: item.name,
                            text: item.name
                        });
                    });
                }

                return list;
            },
        },
        methods: {
            ...mapActions([
                'getReport',
                'getPostTypes',
                'getUsers',
                'getMenus',
            ]),
            dateFormatOptions(date) {
                return moment(date).format('YYYY-MM-DD ');
            },
            dateFromSelected(date) {
                this.$set(this.filter, 'date_from', moment(date).format('YYYY-MM-DD ').trim());
            },
            dateToSelected(date) {
                this.$set(this.filter, 'date_to', moment(date).format('YYYY-MM-DD ').trim());
            },
            getFilters() {
                if(this.filterParams.filters) {
                    return Object.assign({}, this.filterParams.filters);
                }
            },
            applyFiltersClick() {
                this.$set(this.filter, 'page', 1);
                this.$router.push({
                        path: this.filterParams.path,
                        params: {
                            page: 1,
                        }
                    }
                );
                this.applyFilters();
            },
            applyFilters() {
                this.getReport({
                    filters: this.filter,
                    url: this.filterParams.path,
                });
            },
            resetFiltersClick() {
                this.resetFilters();
                this.applyFilters();
            },
            resetFilters() {
                this.$store.commit('setReportFilters', Object.assign({}, this.initialFilters));
            },
            isPostTypeReport() {
                if(this.filterParams) {
                    return this.filterParams.type == 'post_type';
                }
            },
            isPostVisitorsReport() {
                if(this.filterParams) {
                    return this.filterParams.type == 'post_visitors';
                }
            },
            isPostCountReport() {
                if(this.filterParams) {
                    return this.filterParams.type == 'post_count';
                }
            }
        },
        mounted(){
            this.getPostTypes();
            this.getUsers({});
            this.resetFilters();
        },
        watch: {
            reportFilters: function(newVal) {

            },
        }
    }
</script>

<style scoped>
    .vdp-datepicker{
        padding: 0px !important;
    }
    .vdp-datepicker >>> input{
        width: 100% !important;
        border: none;
        padding: 7px;
        margin: 0px;
        border: none;
    }
    .show-btn{
        margin-top: auto;
    }
    .btn-holder{
        margin-top: auto;
    }
</style>
